import { Title, Body, Subtitle } from '@panwds/react-ui'
import type { VFC } from 'react'

const UAccordionHeader: VFC<{ title: string, subtitle?: string}> = ({ title, subtitle }) => {
  return (
    <div className='cm-w-full cm-mb-3'>
      <Title level={3} size='xs'>{title}</Title>
      {subtitle &&
        <Subtitle>
          <Body addClassName='cm-pr-2' appearance='secondary' as='span'>{subtitle}</Body>
        </Subtitle>
      }
    </div>
  )
}

export default UAccordionHeader
